import React, { useCallback, useEffect, useState } from "react";
import TableLayout from "../components/table";
import { Box, Paper } from "@mui/material";
import {
  getAllVendorName,
  getFilteredTransactionAll,
  getAllOrgName,
  getAllTransaction,
  getAllOpsMember,
  getFilteredTransactionAllDownload,
  getAllTransactionDownload,
} from "../services/httpCalls";
import { getcookieFunc } from "../utils/useCookies";
import { showloader } from "../store/gloabalState";
import { useSetRecoilState } from "recoil";
import {
  Button,
  Drawer,
  Form,
  Input,
  Table,
  Typography,
  Space,
  Select,
  Divider,
  DatePicker,
  Tooltip,
  Badge,
  Radio,
} from "antd";
import { DateConvert } from "../utils/dateConverter";
import { Link } from "react-router-dom";
import { transactionClicked } from "../store/gloabalState";
import {
  Close,
  Download,
  ReplayCircleFilled,
  FilterAlt,
} from "@mui/icons-material";
import "../assets/styles/alltxn.scss";
import useNotify from "../utils/useNotify";
import FileDownload from "js-file-download";
import JsFileDownloader from "js-file-downloader";
export default function AllTransaction(props) {
  const [allTransacations, setAllTransactions] = useState();
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [vendorName, setVendorName] = useState();
  const [orgName, setOrgName] = useState();
  const [opsMembers, setOpsMember] = useState();
  const setTransactionId = useSetRecoilState(transactionClicked);
  const [filtervalues, setFilterValues] = useState({});
  const [filterModeOn, setFilterModeOn] = useState(false);
  const [dateRangeBy, setDateRangeBy] = useState("isDateRangeOnCompletionTime");
  const setShowLoader = useSetRecoilState(showloader);
  const [alltxnForm] = Form.useForm();
  const { RangePicker } = DatePicker;
  let accessToken = getcookieFunc();
  const [openDrawer, setOpenDrawer] = useState(false);
  const notify = useNotify();
  const showDrawer = () => {
    setOpenDrawer(true);
  };

  const onCloseDrawer = () => {
    setOpenDrawer(false);
  };
  const isObjectEmpty = (objectName) => {
    return (
      Object.keys(objectName).length === 0 && objectName.constructor === Object
    );
  };
  const getTransactions = (currentPage) => {
    setShowLoader(true);
    getTransactionsWithFilters(filtervalues, currentPage);
  };
  const getAllVendorList = async () => {
    await getAllVendorName()
      .then((res) => {
        let finalVendorName = res?.map((ven) => {
          return {
            label: ven?.name ? ven?.name : "--",
            value: ven?.id,
          };
        });
        if (finalVendorName?.length) {
          setVendorName(finalVendorName);
        } else {
          setVendorName([]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getAllOrgList = async () => {
    await getAllOrgName()
      .then((res) => {
        let finalCustName = res?.map((cust) => {
          return {
            label: cust?.name ? cust?.name : "--",
            value: cust?.id,
          };
        });
        if (finalCustName?.length) {
          setOrgName(finalCustName);
        } else {
          setOrgName([]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getOpsMember = () => {
    getAllOpsMember().then((res) => {
      let opsMember = res;
      let finalOps;
      if (Object.keys(opsMember).length) {
        finalOps = Object.keys(opsMember).map((ops, i) => {
          return {
            label: ops,
            value: [Object.values(opsMember)[i]],
          };
        });
        if (finalOps?.length) {
          let formattedOps = finalOps.map((ops) => {
            return {
              label: ops?.label,
              value: ops?.value.join(""),
            };
          });
          setOpsMember(formattedOps);
        }
      }
    });
  };

  function formatDate(date) {
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Add 1 to month since it's 0-based
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  }

  const getTransactionsWithFilters = (filtervalues, currentPage) => {
    if (filtervalues) {
      let organisationId = "";
      let vendorId = "";
      let fromDate = "";
      let toDate = "";
      let assignedOpsMemberId = "";
      let stage = "";
      let dateRangeByVal_ = "";
      if (isObjectEmpty(filtervalues) === false) {
        if (filtervalues.CustomerListSelection?.length) {
          organisationId += filtervalues.CustomerListSelection;
        }
        if (filtervalues.VendorListSelection?.length) {
          vendorId += filtervalues.VendorListSelection;
        }
        if (filtervalues.toFrom?.length) {
          if (filtervalues?.toFrom[0]) {
            const originalDate = new Date(filtervalues.toFrom[0]);
            const formattedDate = formatDate(originalDate);
            fromDate = filtervalues?.toFrom[0]
              ? Number(new Date(`${formattedDate} 00:00`))
              : "";
          }
          if (filtervalues?.toFrom[1]) {
            const originalDate = new Date(filtervalues.toFrom[1]);
            const formattedDate = formatDate(originalDate);
            toDate = filtervalues?.toFrom[1]
              ? Number(new Date(`${formattedDate} 23:59:59`))
              : "";
          }
          // if (filtervalues?.toFrom[0]) {
          //   let dateFormat = "MM/DD/YYYY"
          //   let date_ = Number(new Date(`${filtervalues.toFrom[0].format(dateFormat)} 00:00:00`))
          //   fromDate = `${date_}`
          // }
          // if (filtervalues?.toFrom[1]) {
          //   let dateFormat = "MM/DD/YYYY"
          //   let date_ = Number(new Date(`${filtervalues.toFrom[1].format(dateFormat)} 23:59:59`))
          //   toDate = `${date_}`
          // }
          if (dateRangeBy) {
            dateRangeByVal_ = dateRangeBy;
          }
        }
        if (filtervalues.assignedOpsMemberId?.length) {
          assignedOpsMemberId += filtervalues.assignedOpsMemberId;
        }
        if (filtervalues.stage?.length) {
          stage += filtervalues.stage;
        }
        let OnlySelected = {
          organisationId: organisationId,
          vendorId: vendorId,
          fromDate: fromDate,
          toDate: toDate,
          assignedOpsMemberId: assignedOpsMemberId,
          status: stage,
        };
        setShowLoader(true);
        let filters = "";
        Object.keys(OnlySelected).map((item) => {
          if (OnlySelected[item] !== "") {
            filters += `${item}=${OnlySelected[item]}&`;
          }
        });
        if (dateRangeByVal_ && filtervalues.toFrom?.length) {
          filters += `${dateRangeByVal_}=true&`;
        }
        // * all transactions are being converted into outward transactions
        if (!filters) {
          filters = `productType=OUTWARD&`;
        } else {
          filters += `productType=OUTWARD&`;
        }
        getFilteredTransactionAll(filters, currentPage)
          .then((res) => {
            setAllTransactions(res.transactionDetailResponseDtoList);
            setTotalCount(res.totalCount);
          })
          .catch((err) => {
            notify.error("Not able to fetch data!");
          })
          .finally(() => setShowLoader(false));
      }
    }
  };

  useEffect(() => {
    getAllOrgList();
    getAllVendorList();
    getOpsMember();
  }, []);

  const retainFilters = async (formSett) => {
    await setFilterValues(formSett);
    if (formSett.stage?.length) {
      alltxnForm.setFieldValue("stage", formSett.stage);
    }
    if (formSett.CustomerListSelection?.length) {
      alltxnForm.setFieldValue(
        "CustomerListSelection",
        formSett.CustomerListSelection
      );
    }
    if (formSett.VendorListSelection?.length) {
      alltxnForm.setFieldValue(
        "VendorListSelection",
        formSett.VendorListSelection
      );
    }
    if (formSett.assignedOpsMemberId?.length) {
      alltxnForm.setFieldValue(
        "assignedOpsMemberId",
        formSett.assignedOpsMemberId
      );
    }
    await getTransactionsWithFilters(formSett, currentPage);
    // setTimeout(async() => {
    // console.log("formValues", filtervalues);
    // }, 1000)
  };
  useEffect(() => {
    getTransactions(currentPage);
  }, [filtervalues, filterModeOn]);

  useEffect(() => {
    let formSett = [];
    if (
      localStorage.getItem("keepfilters") !== null ||
      localStorage.getItem("keepfilters") !== undefined
    ) {
      let filtersLocalStorage = localStorage.getItem("keepfilters");
      if (filtersLocalStorage) {
        formSett = JSON.parse(filtersLocalStorage);
      }
    }
    retainFilters(formSett);
  }, [currentPage, filterModeOn]);

  const handleFiltersDownload = async () => {
    if (Object.keys(filtervalues).length === 0) {
      let defaultFilters = `fromDate=${Number(
        new Date(Date.now() - 2592000000).setHours(0, 0, 0, 0)
      )}&toDate=${Number(Date.now())}`;

      setShowLoader(true);
      await getAllTransactionDownload(defaultFilters)
        .then((res) => {
          if (res !== "" && res !== undefined) {
            FileDownload(res, "Transaction.xlsx");
            notify.success("Downloaded!");
          } else {
            notify.error("Not able to download file in given filter!");
          }
        })
        .catch((err) => {
          notify.error("Error while Downloading!");
        })
        .finally(() => {
          setShowLoader(false);
        });
    } else {
      setShowLoader(true);
      const originalDateFrom = new Date(filtervalues?.toFrom?.[0]);
      const formattedDateFrom = formatDate(originalDateFrom);
      const originalDateTo = new Date(filtervalues?.toFrom?.[1]);
      const formattedDateTo = formatDate(originalDateTo);
      let OnlySelectedFilters = {
        organisationId: filtervalues?.CustomerListSelection
          ? filtervalues?.CustomerListSelection.join(",")
          : "",
        vendorId: filtervalues?.VendorListSelection
          ? filtervalues?.VendorListSelection.join(",")
          : "",
        fromDate: filtervalues?.toFrom?.length
          ? filtervalues?.toFrom[0]
            ? Number(new Date(`${formattedDateFrom} 00:00`))
            : Number(new Date(Date.now() - 2592000000).getTime())
          : Number(new Date(Date.now() - 2592000000).setHours(0, 0, 0, 0)),
        toDate: filtervalues?.toFrom?.length
          ? filtervalues?.toFrom[1]
            ? Number(new Date(`${formattedDateTo} 23:59:59`))
            : Number(Date.now())
          : Number(Date.now()),
        asssignedOpsMemberId: filtervalues?.assignedOpsMemberId
          ? filtervalues?.assignedOpsMemberId.join(",")
          : "",
        status: filtervalues?.stage ? filtervalues?.stage.join(",") : "",
      };
      if (dateRangeBy) {
        OnlySelectedFilters[`${dateRangeBy}`] = true;
      }
      let filters = "";
      Object.keys(OnlySelectedFilters).map((item) => {
        if (OnlySelectedFilters[item] !== "") {
          filters += `${item}=${OnlySelectedFilters[item]}&`;
        }
      });
      getFilteredTransactionAllDownload(filters)
        .then((res) => {
          if (res !== "" && res !== undefined) {
            FileDownload(res, "Transaction.xlsx");
            notify.success("Downloaded!");
          } else {
            notify.error("Not able to download file in given filter!");
          }
        })
        .catch((err) => {
          notify.error("Error while Downloading!");
        })
        .finally(() => setShowLoader(false));
    }
  };

  const handleChange = async (pagination) => {
    setCurrentPage(pagination.current - 1);
  };
  const stagesFilter = [
    {
      label: "Completed",
      value: "COMPLETED",
    },
    {
      label: "Initiated",
      value: "INITIATED",
    },
    {
      label: "15 CB",
      value: "CB15",
    },
    {
      label: "15 CA",
      value: "CA15",
    },
    {
      label: "Transaction Initiated",
      value: "TRANSACTION_INITIATED",
    },
    {
      label: "Approved",
      value: "APPROVED",
    },
    {
      label: "Fund Requested",
      value: "FUND_REQUESTED",
    },
    {
      label: "Dropped",
      value: "DROPPED",
    },
    {
      label: "Documents prepared",
      value: "DOCUMENT_PREPARED",
    },
  ];
  const cols = [
    {
      title: "TransactionId",
      dataIndex: "transactionId",
      key: "transactionId",
      align: "center",
      render: (val, record) => (
        <Link
          to={"/transactiondetail/" + record?.transactionId}
          style={{
            color: "#000",
          }}
          onClick={() => {
            setTransactionId(record?.transactionId);
          }}
        >
          {record?.transactionId}
        </Link>
      ),
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
      align: "center",
      filterSearch: true,
      render: (val) => (val ? val : "-"),
    },
    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      key: "vendorName",
      align: "center",
      render: (val) => {
        return val === null ? "-" : val;
      },
      width: 200,
    },
    {
      title: "Initiated Date",
      dataIndex: "initiationDate",
      key: "initiationDate",
      align: "center",
      render: (val, record) =>
        DateConvert(record?.initiationDate)
          ? DateConvert(record?.initiationDate)
          : "-",
    },
    {
      title: "Last Updated",
      dataIndex: "lastUpdatedDate",
      key: "lastUpdatedDate",
      align: "center",
      render: (val, record) =>
        DateConvert(record?.lastUpdatedDate)
          ? DateConvert(record?.lastUpdatedDate)
          : "-",
    },
    {
      title: "Completion Date",
      dataIndex: "completionDate",
      key: "completionDate",
      align: "center",
      render: (val, record) =>
        DateConvert(record?.completionDate)
          ? DateConvert(record?.completionDate)
          : "-",
    },
    {
      title: "Stage",
      dataIndex: "stageName",
      key: "stage",
      align: "center",
      render: (val) => (val ? val : "-"),
    },
    {
      title: "Assigned To",
      dataIndex: "assignedOpsMember",
      key: "assignedOpsMember",
      align: "center",
      render: (val) => (val ? val : "-"),
    },

    {
      title: "Amount",
      // dataIndex: 'amount',
      key: "amount",
      align: "center",
      render: (val, record) =>
        `${record?.currencyCode ? record.currencyCode : "-"} ${
          record.amount ? record.amount : "-"
        }`,
    },
    {
      title: "Bank Used",
      dataIndex: "vendorBankName",
      key: "vendorBankName",
      render: (val) => (val ? val : "-"),
      align: "center",
    },
    {
      title: "Bank Name",
      dataIndex: "bankName",
      key: "bankName",
      align: "center",
      render: (val) => (val ? val : "-"),
    },
    {
      title: "Transaction Type",
      dataIndex: "transactionType",
      key: "transactionType",
      align: "center",
      render: (val) => (val ? val : "-"),
    },
  ];

  return (
    <Box
      className={props.activeTab ? props.activeTab + " tabmain" : "tabmain"}
      sx={{ padding: "1rem", width: "100%" }}
    >
      <div className="alltnx_container">
        <Typography.Title level={2}>Outward Transactions</Typography.Title>

        <div className="alltxn_buttons_container">
          <Tooltip title="Reset all filters and sync with latest data">
            <Button
              icon={<ReplayCircleFilled />}
              type="ghost"
              onClick={() => {
                alltxnForm.resetFields();
                setFilterValues({});
                setCurrentPage(0);
                setFilterModeOn(!filterModeOn);
                localStorage.removeItem("keepfilters");
              }}
            >
              RESET
            </Button>
          </Tooltip>
          {/* <Badge count={Object.keys(filtervalues)?.length ? 1 : 0}> */}
          <Button
            type="primary"
            onClick={showDrawer}
            icon={<FilterAlt />}
          ></Button>
          {/* </Badge> */}
          <Button
            type="primary"
            icon={<Download />}
            onClick={handleFiltersDownload}
          >
            Download
          </Button>
        </div>
      </div>
      <Box component={Paper}>
        <Table
          columns={cols}
          dataSource={allTransacations}
          style={{}}
          pagination={{
            pageSize: 10,
            total: totalCount,
            showSizeChanger: false,
            position: ["bottomCenter"],
            current: currentPage + 1,
          }}
          rowKey={(record) => record?.transactionId}
          onChange={handleChange}
          className="styledAntd"
        />
      </Box>

      <Drawer
        open={openDrawer}
        onClose={onCloseDrawer}
        title={
          <Typography.Title
            level={4}
            style={{
              margin: 0,
              padding: 0,
              textTransform: "uppercase",
            }}
          >
            Table Filters
          </Typography.Title>
        }
        closeIcon
        extra={
          <Space>
            <Button
              icon={<Close />}
              type="ghost"
              onClick={onCloseDrawer}
            ></Button>
          </Space>
        }
      >
        <Form
          layout="vertical"
          onFinish={(values) => {
            if (
              values?.CustomerListSelection === undefined &&
              values?.VendorListSelection === undefined &&
              values?.toFrom === undefined &&
              values?.assignedOpsMemberId === undefined &&
              values?.stage === undefined
            ) {
              setFilterValues({});
              onCloseDrawer();
              setFilterModeOn(!filterModeOn);
              return;
            }
            localStorage.setItem("keepfilters", JSON.stringify(values));
            setCurrentPage(0);
            setFilterValues(values);
            setFilterModeOn(!filterModeOn);
            onCloseDrawer();
          }}
          form={alltxnForm}
        >
          <Typography.Title
            level={5}
            style={{
              textTransform: "uppercase",
            }}
          >
            Filter by Customer Name
          </Typography.Title>

          <Form.Item
            name={"CustomerListSelection"}
            label="Search and Select Customers"
            tooltip="You can add multiple customers"
          >
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              placeholder="Select Customers you want to filter"
              optionLabelProp="label"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={orgName?.length ? orgName : []}
            ></Select>
          </Form.Item>
          <Divider />
          <Typography.Title
            level={5}
            style={{
              textTransform: "uppercase",
            }}
          >
            Filter by Vendor Name
          </Typography.Title>
          <Form.Item
            name={"VendorListSelection"}
            label="Search and Select Vendors"
            tooltip="You can add multiple vendors"
          >
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              placeholder="Select Vendors you want to filter"
              optionLabelProp="label"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={vendorName?.length ? vendorName : []}
            ></Select>
          </Form.Item>
          <Divider />
          <Typography.Title
            level={5}
            style={{
              textTransform: "uppercase",
            }}
          >
            Filter by Date range
          </Typography.Title>
          <Form.Item label={"Date Range By"} name={"dateRangeByVal"}>
            <Radio.Group
              onChange={(e) => setDateRangeBy(e.target.value)}
              defaultValue={dateRangeBy}
            >
              <Radio value={"isDateRangeOnCompletionTime"}>
                Completion Date
              </Radio>
              <Radio value={"isDateRangeOnLastUpdatedTime"}>
                Last Updated Date
              </Radio>
              <Radio value={"isDateRangeOnCreationTime"}>Initiated Date</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label="Select Date Range"
            tooltip="Provide from and to date"
            name={"toFrom"}
          >
            <RangePicker />
          </Form.Item>
          <Divider />
          <Typography.Title
            level={5}
            style={{
              textTransform: "uppercase",
            }}
          >
            Filter by Assigned To
          </Typography.Title>

          <Form.Item
            label="Select Assigned Ops Member"
            tooltip="You can choose Ops member"
            name="assignedOpsMemberId"
          >
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              placeholder="Select assigned ops you want to filter"
              optionLabelProp="label"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={opsMembers?.length ? opsMembers : []}
            ></Select>
          </Form.Item>
          <Divider />
          <Typography.Title
            level={5}
            style={{
              textTransform: "uppercase",
            }}
          >
            Filter by Stage
          </Typography.Title>

          <Form.Item
            label="Select Stage"
            tooltip="You can filter by stage of transaction"
            name="stage"
          >
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              placeholder="Select Stages you want to filter"
              optionLabelProp="label"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={stagesFilter?.length ? stagesFilter : []}
            ></Select>
          </Form.Item>
          <Space size={"middle"}>
            <Button htmlType="submit" type="primary">
              Submit
            </Button>
            <Button
              onClick={() => {
                alltxnForm.resetFields();
                setFilterValues({});
                setFilterModeOn(!filterModeOn);
                onCloseDrawer();
                setCurrentPage(0);
                localStorage.removeItem("keepfilters");
              }}
            >
              Reset All
            </Button>
          </Space>
        </Form>
      </Drawer>
    </Box>
  );
}
